"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUrlSearchParamsForTokenRevocation = exports.createUrlSearchParamsForTokenExchange = exports.createUrlSearchParamsForSignInSignUp = void 0;
const resolveIdentityProviderFromUrl_1 = require("./resolveIdentityProviderFromUrl");
const resolveRedirectUrl_1 = require("./resolveRedirectUrl");
const getSearchParamValueFromUrl_1 = require("./getSearchParamValueFromUrl");
const createUrlSearchParamsForSignInSignUp = ({ url, oAuthConfig, userPoolClientId, state, origin, codeVerifier, }) => {
    const resolvedProvider = (0, resolveIdentityProviderFromUrl_1.resolveIdentityProviderFromUrl)(url);
    const lang = (0, getSearchParamValueFromUrl_1.getSearchParamValueFromUrl)(url, 'lang');
    const redirectUrlSearchParams = new URLSearchParams({
        redirect_uri: (0, resolveRedirectUrl_1.resolveRedirectSignInUrl)(origin, oAuthConfig),
        response_type: oAuthConfig.responseType,
        client_id: userPoolClientId,
        scope: oAuthConfig.scopes.join(' '),
        state,
        code_challenge: codeVerifier.toCodeChallenge(),
        code_challenge_method: codeVerifier.method,
    });
    if (resolvedProvider) {
        redirectUrlSearchParams.append('identity_provider', resolvedProvider);
    }
    if (lang) {
        redirectUrlSearchParams.append('lang', lang);
    }
    return redirectUrlSearchParams;
};
exports.createUrlSearchParamsForSignInSignUp = createUrlSearchParamsForSignInSignUp;
const createUrlSearchParamsForTokenExchange = (input) => new URLSearchParams(input);
exports.createUrlSearchParamsForTokenExchange = createUrlSearchParamsForTokenExchange;
const createUrlSearchParamsForTokenRevocation = (input) => new URLSearchParams(input);
exports.createUrlSearchParamsForTokenRevocation = createUrlSearchParamsForTokenRevocation;
